//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionEventTopEntity",
  components: {
    YandexTicketBueButton: () => import('@/components/common/YandexTicketBueButton'),
    TopEntityComponent: () => import('@/components/common/TopEntityComponent'),
    Section: () => import('@/components/common/Section/index'),
    Button: () => import("@/components/common/Button"),
  },
  computed: {
    ...mapGetters({
      label: "event/label",
      yabilet: "event/yabilet",
      images: "event/images",
      place: "event/place",
      address: "event/address",
      accessibleEnvironment: "event/accessibleEnvironment",
      stoppedAt: "event/stoppedAt",
      startedAt: "event/startedAt",
      createdAt: "event/createdAt",
      hasTickets: "event/hasTickets",
    }),
    yabiletClientKey() {
      return this.$config.yandex.tickets.key
    },
    yabiletId() {
      return this?.yabilet?.id
    },
    yabiletRegionId() {
      return this?.yabilet?.regionId
    },
    placeAddress() {
      return this?.place?.address
    },
    placeTitle() {
      return this?.place?.title
    },
    time() {
      if ((this.startedAt || this.createdAt) && this.stoppedAt) {
        const started = this.$moment.unix(this.startedAt || this.createdAt)
        const stopped = this.$moment.unix(this.stoppedAt)

        if (this.$moment(started).unix() > this.$moment(stopped).unix()) {
          return ''
        }

        if (this.$moment(started).unix() === this.$moment(stopped).unix()) {
          return `${this.$moment(started).format("HH:mm")}`
        }

        const day = 1000 * 60 * 60 * 24
        const minute = 1000 * 60
        const dayWithoutOneMinute = day - minute
        const range = stopped - started

        if (
          (
            this.$moment(started).format("HH:mm") === '00:00' ||
            this.$moment(started).format("HH:mm") === '23:59'
          )
          && (
            this.$moment(stopped).format("HH:mm") === '00:00' ||
            this.$moment(stopped).format("HH:mm") === '23:59'
          )
          && (range === day || range === dayWithoutOneMinute)
        ) {
          return this.$t('pages.event-view.time-around-the-clock')
        }
        if (range === day || range === dayWithoutOneMinute) {
          return `${this.$moment(started).format("HH:mm")}`
        }
        if (range < dayWithoutOneMinute) {
          return `${this.$moment(started).format("HH:mm")} – ${this.$moment(stopped).format("HH:mm")}`
        }
        if (range > day) {
          return `${this.$moment(started).format("HH:mm")}`
        }
      }
      return ''
    },
    date() {
      const start = this.startedAt === null ? '' : this.$moment.unix(this.startedAt).format('DD.MM.YYYY')
      const stop = this.stoppedAt === null ? '' : this.$moment.unix(this.stoppedAt).format('DD.MM.YYYY')
      if (start && !stop) {
        return `${this.$t('pages.event-view.date-start')} ${start}`
      } else if (!start && stop) {
        return `${this.$t('pages.event-view.date-stop')} ${stop}`
      } else {
        return start && stop ? `${start} – ${stop}` : ''
      }
    },
  },
  mounted() {
    if (this.yabiletId) {
      const YandexTicketsDealer = window.YandexTicketsDealer = window.YandexTicketsDealer || []
      YandexTicketsDealer.push(['setDefaultClientKey', this.$config.yandex.tickets.key])
      YandexTicketsDealer.push(['setDefaultRegionId', this.yabiletRegionId])
      YandexTicketsDealer.push(['widgetDisplayType', 'popup'])
      /* Загрузка */
      const rnd = '?' + new Date().getTime() * Math.random()
      const script = document.createElement('script')
      const target = document.getElementsByTagName('script')[0]
      script.async = true
      script.src = 'https://widget.afisha.yandex.ru/dealer/dealer.js' + rnd
      target.parentNode.insertBefore(script, target)
    }
  },
  methods: {
    anchorToCalendar() {
      this.$handleScrollTo("#schedule-calendar", 100);
    },
  }
};
